// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"wn_a bhv_b bhv_ux"};